export default "/images/vendor/@coreui/icons/svg/flag/cif-ao.svg?6ebc4d6a872cb769b76fb5d15c9a821f";